import { environment } from './../../../../../environment/environment';
import { CandidatService } from './../../../../core/services/candidat-service/candidat.service';
import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { serverError } from './../../../../core/models/messages';
import { LocalStorageService } from '@core/services/local-storage.service';
import { CvType } from '@core/models/enums/cv-type.enum';
import { ExportService } from '@shared/services/export.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
const DOMPurify = require('dompurify')
import { CompanyService } from './../../../../core/services/company/company.service';
@Component({
  selector: 'app-cv-candidat',
  templateUrl: './cv-candidat.component.html',
  styleUrls: ['./cv-candidat.component.css'],
})
export class CvCandidatComponent {
  
  logo: any;
  emailImage = 'assets/image_cv/email-svg.svg';
  linkedinImage = 'assets/image_cv/linkedin.svg';
  locationImage = 'assets/image_cv/location.svg';
  telephoneImage = 'assets/image_cv/telephone.svg';
  aboutImage = 'assets/image_cv/about-icon.svg';
  skillsImage = 'assets/image_cv/skills-image.png';
  softSkillsImage = 'assets/image_cv/softSkills.png';
  starImage='assets/image_cv/start.svg';
  starinactiveImage='assets/image_cv/star-inactive.svg';
  imageLogo='assets/media/logos/logo-wegestu-color.png'; 
  experienceImage='assets/image_cv/experience-image.svg';
  graduationImage='assets/image_cv/graduation-svg.svg';
  certificateImage='assets/image_cv/certificate.svg';
  languageImage='assets/image_cv/language.svg';
  baseUrl_Company = environment.baseUrlGaleryCompany;
  constructor(
    private spinner: NgxSpinnerService,
    private candidatService: CandidatService,
    private activatedRoute: ActivatedRoute,
    private toastrService: ToastrService,
    private router: Router,
    private localStorageService: LocalStorageService,
    private exportService: ExportService,
    private sanitizer: DomSanitizer,
    private companyService: CompanyService,
  ) {}
  connectedUser: any;
  endIndex: number = 5;
  id:any;
  idCandidat: any;
  selectedCandidate: any;
  totalItems: any;
  skillsCandidat: any;
  private unsubscribeAll: Subject<void> = new Subject();
  typeCv:any;
  /* string */
  url: string = environment.baseUrl;
  ESNId:any;
  cvType: string | undefined;
  cvTypeEnum = CvType

  ngOnInit(): void {
     const connectedUser = JSON.parse(this.localStorageService.getData('UserInfo') || '{}')
   
    this.id = connectedUser?.company?.uuid
    window.scrollTo(0, 0);
    this.getRoutingParams();
    this.getSkills();
    this.getuserById();
    this.connectedUser = this.localStorageService.getData('userConnected');
  }

removeHtmlTags(html: string | undefined): string {
  if (!html) {
    return '';
  }
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = html; 
  return tempDiv.textContent || ''; 
}
capitalizeFirstLetter(string:any) {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}
/* get candidate skills */
  getSanitizedDescription(description: string): SafeHtml {
    const sanitizedHtml = DOMPurify.sanitize(description);
    return this.sanitizer.bypassSecurityTrustHtml(sanitizedHtml);
}

  getRoutingParams() {
    this.activatedRoute.params.subscribe(params => {
      this.idCandidat = params['idCandidat'];
       this.typeCv = params['type'];
      this.getCandidateById()
    });

    if (history.state && history.state.type) {
      const type = history.state.type
      if (type === this.cvTypeEnum.WEGESTU || type === this.cvTypeEnum.ESN) {
        this.cvType = type;
      } else{
        this.router.navigateByUrl('/404')
      }
    }  else{
      this.router.navigateByUrl('/404')
    } 
  }
  getCandidateById() {
    this.spinner.show();
    this.candidatService
      .getUserByIdd(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res: any) => {
          this.selectedCandidate = res.data[0];
          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
        },
      });
  }

getuserById() {
      this.spinner.show();
      this.companyService
        .getCompanydetail(this.id)
        .pipe(takeUntil(this.unsubscribeAll))
        .subscribe({
          next: (res) => {
            this.spinner.hide();
            if(res?.data?.length > 0 ){
              this.logo =`${this.url}/api/Company/file/gallery_company/${res.data[0].logo}`;
            }
            this.spinner.hide();
          },
          error: () => {
            this.spinner.hide();
          },
        });
    // }
  }

  formatPeriod(period: string): string {
    if (!period) return '';
  
    const matches = period.match(/(\d+) ans, (\d+) mois, (\d+) jours/);
    if (!matches) return period;
  
    const years = parseInt(matches[1], 10);
    const months = parseInt(matches[2], 10);
  
    if (years === 0 && months === 0) {
      return `moins d'un mois`;
    } else {
      let result = '';
  
      if (years > 0) {
        result += `${years} An${years > 1 ? 's' : ''}`;
      }
      if (months > 0) {
        if (result.length > 0) result += ', ';
        result += `${months} Mois`;
      }
  
      return result;
    }
  }
  getSkills() {
    this.candidatService
      .getSkillsCandidate(this.idCandidat)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.skillsCandidat =
            res.data.categoriesWithSubCategoriesAndSkills.slice(
              0,
              this.endIndex
            );
          this.totalItems = res.data.count;
        },
        error: (err) => {
          this.toastrService.error(serverError);
        },
      });
  }
  exportToPDF() {
    const element = document.getElementById('kt_app_content');

    if (element) {
      this.spinner.show();
      html2canvas(element).then((canvas) => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF();
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save('export_Cv.pdf');
        this.spinner.hide();
      });
    }
  }
  NavigateToUpdateCandidate() {
    this.router.navigate([
      '/candidats/profil-candidat/update',
      { idCandidat: this.idCandidat },
    ]);
  }

  /**
  * Download CV.
  *  
  * @param {string} cvType - The type of CV to export (e.g., WEGESTU or ESN).
  * @param {number} isAnonymous - Whether to export an anonymous version of the CV (1 : not anonymous, 2 : anonymous) .
  * @returns {void}
  */
  downloadCV(cvType : string | undefined, isAnonymous: number){      
    if(cvType === this.cvTypeEnum.WEGESTU){
      this.exportCVCandidate(isAnonymous, null)
    }else{
      this.exportCVCandidate(isAnonymous, this.selectedCandidate?.ESN_id)
    }
}

// @TOFIX: duplicated
/**
* Exports the CV of a candidate based on the specified type and company ID.
*
* @param {number} type - The type of CV to export (e.g., 1 for standard, 2 for anonymous)
* @param {number | null} idCompany - The ID of the company for which the CV is being exported.
*                          Use `null` if no specific company is associated.
*/
exportCVCandidate(type: number, idCompany : number | null) {
  this.spinner.show();
  const candidate = {
    ids: [this.idCandidat],
    last_name: this.selectedCandidate?.last_name,
    first_name: this.selectedCandidate?.first_name
  } 

    const exportMethod = idCompany !== null
    ? this.exportService.exportCVEsnCandidate(candidate, type, idCompany)
    : this.exportService.exportCVWegestuCandidate(candidate, type);

  exportMethod.subscribe({
    next: () => {
      this.spinner.hide();
    },
    error: () => {
      this.spinner.hide();
    },
  });
}
  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
